<template>
  <div class="leftnav">
    <el-menu router
             :collapse-transition="false"
             :unique-opened='true'
             text-color="#939393"
             background-color="#272727"
             class="el-menu-vertical-demo"
             :default-active="myRoute">
      <template v-for="(item,index) in content">
        <el-submenu :index="item.path"
                    v-if="item.children"
                    :key="index">
          <template slot="title">
            <i class="iconfont"
               v-if='item.name==="图片管理"'>&#xe613;</i>
            <i class="iconfont"
               v-if='item.name==="文章管理"'>&#xe652;</i>
            <i class="iconfont"
               v-if='item.name==="视频管理"'>&#xe661;</i>
            <i class="iconfont"
               v-if='item.name==="其他设置"'>&#xe62a;</i>
            <i class="iconfont"
               v-if='item.name==="特殊设置"'>&#xe629;</i>
            <i class="iconfont"
               v-if='item.name==="BANNER"'>&#xe61a;</i>
            {{item.name}}
          </template>
          <el-menu-item :index="item.path+'?'+item1.config"
                        v-for="item1 in item.children"
                        :key="item.path+'?'+item1.config"
                        class="el-menu-li"
                        @click="getConfig(item,item1)"
                        :title="item1.name">{{item1.name}}</el-menu-item>
        </el-submenu>
      </template>

      <el-submenu index="2"
                  v-if="!this.$store.state.columnId">
        <template slot="title">
          <i class="iconfont">&#xe611;</i>
          <span>SEO管理</span>
        </template>
        <template v-for="(item,index) in seo">
          <el-submenu :index="item.path"
                      v-if="item.children"
                      :key="index">
            <template slot="title">{{item.name}}</template>
            <el-menu-item :index="item.path+'?'+item1.config"
                          v-for="item1 in item.children"
                          :key="item.path+'?'+item1.config"
                          class="el-menu-li"
                          @click="getConfig(item,item1)">{{item1.name}}</el-menu-item>
          </el-submenu>
          <el-menu-item :index="item.path"
                        v-else
                        @click="getConfig(item)"
                        :key="item.path">{{item.name}}</el-menu-item>
        </template>
      </el-submenu>
    </el-menu>
    <el-main>
      <router-view />
    </el-main>
  </div>
</template>
<script>
export default {
  data() {
    return {
      myRoute: localStorage.getItem('myRoute') || '',
    };
  },
  mounted() {
    if (localStorage.getItem('columnType')) {
      this.$store.commit('setNavName', localStorage.getItem('columnType'));
    }

    if (localStorage.getItem('myRoute')) {
      if (localStorage.getItem('myRoute').indexOf('article') >= 0) {
        const data = {
          type: localStorage.getItem('columnType'),
          wid: this.$store.state.websiteId,
          pageSize: 20,
          pageNum: 1,
        };
        this.$store.dispatch('getArticle', data);
      } else if (localStorage.getItem('myRoute').indexOf('img') >= 0) {
        const data = {
          type: localStorage.getItem('columnType'),
          wid: this.$store.state.websiteId,
        };
        this.$store.dispatch('getImages', data);
      } else if (localStorage.getItem('myRoute').indexOf('other_set') >= 0) {
        this.$store.commit('getconfig', JSON.parse(localStorage.getItem('myConfig')));
      }
    }
  },
  methods: {
    getConfig(item, item1) {
      if (item1) {
        this.$store.commit('setNavName', item1.name);
        localStorage.setItem('columnType', item1.name);
        this.myRoute = `${item.path}?${item1.config}`;
      } else {
        this.$store.commit('setNavName', item.name);
        localStorage.setItem('columnType', item.name);
        this.myRoute = item.path;
      }
      localStorage.setItem('myRoute', this.myRoute);
      if (item.name === '文章管理') {
        const data = {
          type: item1.name,
          wid: this.$store.state.websiteId,
          pageSize: 20,
          pageNum: 1,
        };
        this.$store.dispatch('getArticle', data);
      } else if (item.name === '图片管理') {
        const data = {
          type: item1.name,
          wid: this.$store.state.websiteId,
        };
        this.$store.dispatch('getImages', data);
      } else if (item.name === '视频管理') {
        const data = {
          type: item1.name,
          wid: this.$store.state.websiteId,
        };
        this.$store.dispatch('getVideoList', data);
      } else if (item.name === 'BANNER') {
        const data = {
          type: item1.name,
          wid: this.$store.state.websiteId,
        };
        this.$store.dispatch('getBannerList', data);
      } else if (item.name === '其他设置') {
        const settings = this.$store.state.settings;
        for (let i = 0; i < settings.length; i += 1) {
          if (settings[i].name === item1.name) {
            this.$store.commit('getconfig', settings[i]);
            localStorage.setItem('myConfig', JSON.stringify(settings[i]));
          }
        }
      } else if (item.name === '特殊设置') {
        const otherSettings = this.$store.state.otherSettings;
        for (let i = 0; i < otherSettings.length; i += 1) {
          if (otherSettings[i].name === item1.name) {
            this.$store.commit('getOtherSettingDetail', otherSettings[i]);
            localStorage.setItem('otherSettingDetail', JSON.stringify(otherSettings[i]));
          }
        }
      }
    },
  },
  created() {
    if (this.$store.state.columnId) {
      this.$store.dispatch('getColumnDetail', { id: this.$store.state.columnId, wid: this.$store.state.websiteId });
    } else {
      this.$store.dispatch('getWebsiteDetail', { id: this.$store.state.websiteId });
    }
  },
  computed: {
    configLeftNav() {
      return this.$store.state.configLeftNav;
    },
    content() {
      return this.$store.state.configLeftNav.content;
    },
    seo() {
      return this.$store.state.configLeftNav.seo;
    },
  },
};
</script>
<style lang="less" scoped>
.el-menu {
  height: 100%;
  color: #fff;
  border: none;
}

.el-aside {
  overflow: inherit;
  background-color: #272727;
  .logo {
    height: 50px;
    background: #000;
    font-size: 16px;
    color: #fff;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    .iconfont {
      font-size: 20px;
      margin-right: 8px;
      &.collapse {
        margin-right: 0;
      }
    }
  }
  .el-menu-item {
    color: #fff;
    height: 50px;
    line-height: 50px;
    user-select: none;
    font-size: 12px;
    width: 140px;
    min-width: 140px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0;
  }
  .el-menu-item.is-active {
    color: #fff;
    background-color: #409eff !important;
  }
  .el-menu-item:focus,
  .el-menu-item:hover {
    color: #fff;
    background-color: #409eff !important;
  }
  .el-menu--horizontal > .el-menu-item:focus,
  .el-menu--horizontal > .el-menu-item:hover {
    background-color: #000;
    color: #fff;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    color: #409eff;
  }
  .el-menu--horizontal > .el-menu-item {
    color: #303133;
  }
  .el-menu {
    height: ~"calc(100vh - 50px)";
    /deep/ .el-menu-item-group {
      background: #404040;
    }
  }
  .mini_menu {
    li {
      text-align: center;
      height: 56px;
      line-height: 56px;
    }
    i {
      color: #fff;
      font-size: 16px;
    }
  }
}

* {
  padding: 0;
  margin: 0;
}
// .el-menu-vertical-demo:not(.el-menu--collapse) {
//   min-width: 180px;
//   height: ~"calc(100vh - 120px)";
//   background: #f5f5f5;
//   overflow: auto;
// }
// .leftnav {
//   position: absolute;
//   left: 0;
//   z-index: 999;
// }
.menu-icon {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/websiteDetailNav.vue